module.exports = __webpack_public_path__ + "static/media/Etiquetas6.90cf4dea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancEtiquetas/Etiquetas6.png
// module id = 2259
// module chunks = 0